import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService, AuthenticationService, NotificationService, TenantService} from '../../_services/index';

import {Company, Tenant} from '../../_models/index';

import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';

import {TenantComponent} from '../tenant/index';

import {CompanyType, LoginHelper, Role} from '../../helpers/index';

//import { MatSort } from '@angular/material/dialog';
//import { MatTableDataSource } from './table-data-source'

import {InitializeTenantComponent} from "../initializeTenant/initializeTenant.component";
import {ConfirmComponent} from "../confirm";


@Component({
    standalone: false,
  selector: "tenants-component",
  templateUrl: 'tenants.component.html',
  styleUrls: ['./tenants.component.scss'],
})

export class TenantsComponent implements OnInit {
  tenantId: string;
  tenants: Tenant[];
  msg: string;
  consultantCompany: Company;
  clientCompany: Company;

  dialogRef: MatDialogRef<TenantComponent> | null;

  cols : any[] = [
    {'field': 'tenantId', 'header': 'Tenant ID'},
    {'field': 'users.length', 'header': '# Users'},
    {'field': 'databaseName', 'header': 'Database Name'},
    {'field': 'creationDate', 'header': 'Creation Date'},
    {'field': 'advisorCompany', 'header': 'Advisor Company'},
    {'field': 'advisorEmail', 'header': 'Advisor Lead E-mail'},
    {'field': 'managerCompany', 'header': 'Manager Company'},
    {'field': 'managerEmail', 'header': 'Manager E-mail'},
    {'field': 'canCreateComplianceArea', 'header': 'Can create Compliance Areas'},
    {'field': 'canCreatePartnerProjects', 'header': 'Can create Vendor Projects'},
    {'field': 'lastLoggedInUsers', 'header': 'Last Logged In'}
  ]

  constructor(
      public route: ActivatedRoute,
      public router: Router,
      public tenantService: TenantService,
      public authenticationService: AuthenticationService,
      public alertService: AlertService,
      public notificationService: NotificationService,
      public dialog: MatDialog) {

      this.tenantId = route.snapshot.params['tenantId'];
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
        this.authenticationService.logout();

        return;
    }

    this.loadTenants();
  }

  editTenant(tenantId: number) {

    let tenant =
      this.tenants.find(x => x.tenantId == tenantId);

    let config : MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '98%',
      height: '90vh',
      data: {
        tenant: tenant
      }
    };

    this.dialogRef = this.dialog.open(TenantComponent, config);

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.loadTenants();
    });
  }

  deleteTenant(tenantId: number) {
    this.dialog.open(ConfirmComponent, {
      data: {
        title: 'Do you want to disable or fully delete (including documents, database, etc) tenant?',
        yes: 'Disable',
        no: 'Delete',
        confirm: () => this.doDeleteTenant(tenantId, false),
        cancel: () => this.doDeleteTenant(tenantId, true)
      }
    })
  }

  doDeleteTenant(tenantId, totalErase)
  {
    this.tenantService.delete(tenantId, totalErase).subscribe(data => {
      this.loadTenants();
      },
      (error : Response) => {
        const errorMessage = 'An error occurred while deleting tenant.';
        this.alertService.error(errorMessage);
    });
  }

  enableTenant(tenantId: number) {
    this.tenantService.enable(tenantId).subscribe(data => {
        this.loadTenants();
      },
      (error : Response) => {
        const errorMessage = 'An error occurred while enabling tenant.';
        this.alertService.error(errorMessage);
      });
  }

  public getConsultantManagerEmail(tenant: Tenant): string{

    const advisorLeads = (tenant.users || []).filter(x => (x.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0);
    if (advisorLeads.length > 0){
      return advisorLeads[0].emailAddress;
    }

    return null;
  }

  public getClientManagerEmail(tenant: Tenant): string{

    const clientManagers = (tenant.users || []).filter(x => (x.role & (Role.Manager | Role.PrimaryManager)) != 0);
    if (clientManagers.length > 0){
      return clientManagers[0].emailAddress;
    }

    return null;
  }

  public getClientCompanyName(tenant: Tenant): string{

    const clientCompanies = (tenant.companies || []).filter(x => x.companyType == CompanyType.Client);
    if (clientCompanies.length > 0){
      return clientCompanies[0].companyName;
    }

    return null;
  }

  public getConsultantCompanyName(tenant: Tenant): string{

    const consultantCompanies = (tenant.companies || []).filter(x => x.companyType == CompanyType.Advisor);
    if (consultantCompanies.length > 0){
      return consultantCompanies[0].companyName;
    }

    return null;
  }

  onSendNotifications(){

    this.notificationService
      .sendNotification()
      .subscribe();
  }

  public getClientCompanyAddress(tenant: Tenant): string{

    const clientCompanies = (tenant.companies || []).filter(x => x.companyType == CompanyType.Client);
    if (clientCompanies.length > 0){

    return clientCompanies[0].streetAddress
          + ', '
          + clientCompanies[0].suiteRoomBuilding
          + ', '
          + clientCompanies[0].city
          + (clientCompanies[0].state != null ? (', ' + clientCompanies[0].state) : '')
          + ', '
          + clientCompanies[0].zip
          + ', '
          + clientCompanies[0].country;
  }

  return null;
}

public getConsultantCompanyAddress(tenant: Tenant): string{

  const consultantCompanies = (tenant.companies || []).filter(x => x.companyType == CompanyType.Advisor);
  if (consultantCompanies.length > 0){

    return consultantCompanies[0].streetAddress
          + ', '
          + consultantCompanies[0].suiteRoomBuilding
          + ', '
          + consultantCompanies[0].city
          + (consultantCompanies[0].state != null ? (', ' + consultantCompanies[0].state) : '')
          + ', '
          + consultantCompanies[0].zip
          + ', '
          + consultantCompanies[0].country;
  }

  return null;
}

  public loadTenants() {
    this.tenantService.getAll().subscribe(data => {
         this.tenants = data;
      },
      error => {
        const errorMessage = 'An error occurred while loading tenant.';
        this.alertService.error(errorMessage);
      });
  }

  public setCanCreateComplianceArea(tenantId: number, value: boolean)
  {
    this.tenantService.setCanCreateComplianceArea(tenantId, value).subscribe(data => {
        this.loadTenants();
      },
      error => {
        const errorMessage = 'An error occurred while setting tenant permissions.';
        this.alertService.error(errorMessage);
      });
  }

  public setCanCreatePartnerProjects(tenantId: number, value: boolean)
  {
    this.tenantService.setCanCreatePartnerProjects(tenantId, value).subscribe(data => {
        this.loadTenants();
      },
      error => {
        const errorMessage = 'An error occurred while setting tenant permissions.';
        this.alertService.error(errorMessage);
      });
  }

  public initializeTenant(tenant: Tenant)
  {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '98%',
      height: '90vh',
      data: {
        tenant: tenant
      }
    };

    const dialogRef = this.dialog.open(InitializeTenantComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result)
      {
        this.loadTenants();
      }
    });

  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
